import { ClassType } from './class-types.enum';

export const LIVE_CLASS_LOCKED_STATE_KEYS = {
  SUBSCRIBE: {
    legacy: 'studybundle.liveClasses.enrollLockMessage',
    pcrevamp: 'oeapp.studybundle.gc.lockedMessage',
  },
  REGISTER: {
    legacy: 'studybundle.liveClasses.registerLockMessage',
    pcrevamp: 'oeapp.studybundle.gc.lockedMessage',
  },
  PC_COMPLETE: {
    legacy: 'privateClasses.completedMessage',
    pcrevamp: 'privateClasses.completedMessage',
  },
  GROUP_COMPLETE: {
    legacy: 'groupClasses.completedMessage',
    pcrevamp: 'groupClasses.completedMessage',
  },
  DISABLED: {
    legacy: 'oeapp.studybundle.gc.signupDisabledMessage',
    pcrevamp: 'oeapp.studybundle.gc.signupDisabledMessage',
  },
};

export type PcRevampType = 'legacy' | 'pcrevamp';

export const LIVE_CLASS_TRANSLATION_KEYS = {
  CAN_SIGN_UP: {
    legacy: {
      buttonCaption: 'studybundle.liveClasses.signUpButton',
    },
    pcrevamp: {
      buttonCaption: 'oeapp.studybundle.gc.signupBtn',
    },
  },

  SIGNUP_CONFIRM: {
    legacy: {
      title: 'studybundle.liveClasses.signUp',
      stateTextKey: 'studybundle.liveClasses.confirmation.line',
      buttonCaption: 'studybundle.liveClasses.confirmation.requestClass',
      showCloseButton: true,
    },
    pcrevamp: {
      title: 'studybundle.liveClasses.signUp',
      buttonCaption: 'oeapp.studybundle.pc.confirmLesson.button',
      showCloseButton: true,
    },
  },
  SIGNED_UP: {
    legacy: {
      title: 'studybundle.liveClasses.signUp',
      stateTextKey: 'studybundle.liveClasses.assignTeacher',
      showLoader: true,
    },
    pcrevamp: {
      title: '',
      stateTextKey: 'oeapp.studybundle.gc.assigningTeacher',
      showLoader: true,
    },
  },

  HAS_JOIN: {
    legacy: {
      title: 'studybundle.liveClasses.signUp',
      stateTextKey: 'studybundle.liveClasses.joinMessage',
      buttonCaption: 'studybundle.liveClasses.joinLink',
    },
    pcrevamp: {
      title: '',
      stateTextKey: 'oeapp.studybundle.gc.joinClassMsg',
      buttonCaption: {
        [ClassType.PRIVATE]: 'oeapp.studybundle.gc.joinClassBtn',
        [ClassType.GROUP]: 'oeapp.studybundle.gc.joinWaitingRoomBtn',
        [ClassType.HYBRID]: 'oeapp.studybundle.gc.joinWaitingRoomBtn',
      },
    },
  },

  HAS_REJOIN: {
    legacy: {
      title: 'studybundle.liveClasses.signUprejoin',
      stateTextKey: 'studybundle.liveClasses.rejoinMessage',
      buttonCaption: 'studybundle.liveClasses.rejoinButton',
    },
    pcrevamp: {
      title: '',
      stateTextKey: 'oeapp.studybundle.gc.joinClassMsg',
      buttonCaption: 'oeapp.studybundle.gc.rejoinClassBtn',
    },
  },

  LOCKED: {},
  NONE: {},
};



// WEBPACK FOOTER //
// ./ts/app/shared/types/live-class-locked-state-keys.ts